var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83333 7.82222C8.41111 7.82222 8.03333 7.98889 7.74445 8.25L3.78333 5.94444C3.81111 5.81667 3.83333 5.68889 3.83333 5.55556C3.83333 5.42222 3.81111 5.29445 3.78333 5.16667L7.7 2.88333C8 3.16111 8.39444 3.33333 8.83333 3.33333C9.75556 3.33333 10.5 2.58889 10.5 1.66667C10.5 0.744444 9.75556 0 8.83333 0C7.91111 0 7.16667 0.744444 7.16667 1.66667C7.16667 1.8 7.18889 1.92778 7.21667 2.05556L3.3 4.33889C3 4.06111 2.60556 3.88889 2.16667 3.88889C1.24444 3.88889 0.5 4.63333 0.5 5.55556C0.5 6.47778 1.24444 7.22222 2.16667 7.22222C2.60556 7.22222 3 7.05 3.3 6.77222L7.25556 9.08333C7.22778 9.2 7.21111 9.32222 7.21111 9.44444C7.21111 10.3389 7.93889 11.0667 8.83333 11.0667C9.72778 11.0667 10.4556 10.3389 10.4556 9.44444C10.4556 8.55 9.72778 7.82222 8.83333 7.82222Z",
    fill: "#79F7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareVideo);
export default __webpack_public_path__ + "static/media/shareVideo.ce22990d8b7f0f1357e1cbb6c507b9ad.svg";
export { ForwardRef as ReactComponent };